module.exports = __webpack_public_path__ + "img/arrival_14.a72b21c6.jpg";